// (function () {
//     'use strict';

//     class CustactPlansController {
//         model = {
//             setting: {},
//             selectListLabours: [],
//             custactPlansList: [],
//         }

//         static $inject = ['utilityService', 'custactPlansService', 'economyService'];
//         constructor(utilityService, custactPlansService, economyService) {
//             this.utilityService = utilityService;
//             this.custactPlansService = custactPlansService;
//             this.economyService = economyService;
//         }

//         async loadSetting() {
//             return this.model.setting = (await this.custactPlansService.getSetting())[0];
//         }

//         async loadLabours() {
//             return this.model.selectListLabours = await this.economyService.listLabours({ activestatus: 'ACT' });
//         }

//         async _loadCustactPlansList() {
//             if (this.model.setting.labour_no?.trim()) {
//                 this.model.custactPlansList = await this.custactPlansService.loadCustPlansList(this.model.setting);
//             }
//         }

//         onLabourChanged(value) {
//             this.model.setting.labour_no = value;

//             if (value) this._loadCustactPlansList();
//         }

//         async $onInit() {
//             this.loadLabours();
//             await this.loadSetting();
//             this._loadCustactPlansList();
//         }
//     }

//     const module = angular.module('imApp');

//     module.component('custactPlans', {
//         templateUrl: 'views/components/views/custactPlans/custactPlans.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: CustactPlansController
//     });
// })();
